import MedicalService from '../../../service/medical';
import _ from "lodash";

const Action = {
    GET_CONTACTS: '[APPLY MEDICAL APP] GET CONTACTS',
    SET_SEARCH_TEXT: '[APPLY MEDICAL APP] SET SEARCH TEXT',
    OPEN_NEW_CONTACT_DIALOG: '[APPLY MEDICAL APP] OPEN NEW CONTACT DIALOG',
    CLOSE_NEW_CONTACT_DIALOG: '[APPLY MEDICAL APP] CLOSE NEW CONTACT DIALOG',
    OPEN_EDIT_CONTACT_DIALOG: '[APPLY MEDICAL APP] OPEN EDIT CONTACT DIALOG',
    CLOSE_EDIT_CONTACT_DIALOG: '[APPLY MEDICAL APP] CLOSE EDIT CONTACT DIALOG',
    ADD_CONTACT: '[APPLY MEDICAL APP] ADD CONTACT',
    UPDATE_CONTACT: '[APPLY MEDICAL APP] UPDATE CONTACT',
    OPEN_ALERT_DIALOG: '[APPLY MEDICAL APP] OPEN ALERT DIALOG',
    CLOSE_ALERT_DIALOG: '[APPLY MEDICAL APP] CLOSE ALERT DIALOG',
};

const ActionCreator = {

    getContacts(routeParams) {
        return async (dispatch) => {

            const data = await MedicalService.listApplyingMedicals(); // routeParams = { id :'all' }

            return dispatch({
                type: Action.GET_CONTACTS,
                payload: data,
                routeParams
            });

        };
    },
    setSearchText(event) {
        return {
            type: Action.SET_SEARCH_TEXT,
            searchText: event.target.value
        }
    },
    closeNewContactDialog() {
        return {
            type: Action.CLOSE_NEW_CONTACT_DIALOG
        }
    },
    openEditContactDialog(data) {
        return {type: Action.OPEN_EDIT_CONTACT_DIALOG, data};
    },
    closeEditContactDialog() {
        return {type: Action.CLOSE_EDIT_CONTACT_DIALOG};
    },
    openValidateMedicalDialog(medicalId) {
        return async (dispatch) => {
            const data = await MedicalService.findById(medicalId);
            dispatch(ActionCreator.openEditContactDialog(data)); // 開啟  contactsDialog
            return dispatch(ActionCreator.openAlertDialog({msg: '已確定醫生資料無誤，發送開通信件', medicalId}));
        };
    },
    openAlertDialog({msg, medicalId}) {
        return {type: Action.OPEN_ALERT_DIALOG, msg, medicalId};
    },
    closeAlertDialog() {
        return {type: Action.CLOSE_ALERT_DIALOG};
    },
    confirmValidateMedical(medicalId) {
        return async (dispatch) => {
            const data = await MedicalService.validateMedical(medicalId); // routeParams = { id :'all' }
            dispatch(ActionCreator.getContacts({id: 'all'})); // 更新 contactsList 的資訊
            dispatch(ActionCreator.openEditContactDialog(data)); // 開啟  contactsDialog
            return dispatch(ActionCreator.closeAlertDialog()); // 關閉 alert dialog
        };
    },
};

const initialState = {
    entities: [],
    searchText: '',
    selectedContactIds: [],
    routeParams: {},
    contactDialog: {
        type: 'new',
        props: {
            open: false
        },
        data: null
    },
    alertDialog: {
        props: {
            open: false
        },
        data: ''
    }
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_CONTACTS: {
            return {
                ...state,
                entities: _.keyBy(action.payload, 'id'),
                routeParams: action.routeParams
            };
        }
        case Action.SET_SEARCH_TEXT: {
            return {
                ...state,
                searchText: action.searchText
            };
        }
        case Action.OPEN_NEW_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'new',
                    props: {
                        open: true
                    },
                    data: null
                }
            };
        }
        case Action.CLOSE_NEW_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'new',
                    props: {
                        open: false
                    },
                    data: null
                }
            };
        }
        case Action.OPEN_EDIT_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'edit',
                    props: {
                        open: true
                    },
                    data: action.data
                }
            };
        }
        case Action.CLOSE_EDIT_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'edit',
                    props: {
                        open: false
                    },
                    data: null
                }
            };
        }
        case Action.OPEN_ALERT_DIALOG: {
            return {
                ...state,
                alertDialog: {
                    props: {
                        open: true
                    },
                    msg: action.msg || '確定醫生資料無誤,發送開通信件嗎?',
                    medicalId: action.medicalId
                }
            };
        }
        case Action.CLOSE_ALERT_DIALOG: {
            return {
                ...state,
                alertDialog: {
                    props: {
                        open: false
                    },
                    msg: ''
                }
            };
        }
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/apply_medical/contacts.js